import { Component } from '@angular/core';

@Component({
  selector: 'app-myproducts',
  templateUrl: './myproducts.component.html',
  styleUrl: './myproducts.component.scss'
})
export class MyproductsComponent {

}
